export default {
  ...BUILD_CONFIG,
  userStorageKey: 'conreign.user',
};



// WEBPACK FOOTER //
// ./src/config.js